export const CAU_MISSING_PLAID_LINK_ERROR_CODE = 'cau_missing_plaid_link';
export const isCauMissingPlaidLinkError = err => {
  var _err$response;
  const data = err === null || err === void 0 || (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.data;
  return (data === null || data === void 0 ? void 0 : data.error_code) === CAU_MISSING_PLAID_LINK_ERROR_CODE || (data === null || data === void 0 ? void 0 : data.cau_error_flag) === 'missing_plaid_link' || (data === null || data === void 0 ? void 0 : data.technicalError) === 'User has no prior linked plaid account';
};
export const CAU_PLAID_LINK_LOG_FLAG = '[cau][web_plaid_link]';
export const CAU_PLAID_OAUTH_RETURN_PATH = '/members/cau';
export const CAU_PLAID_OAUTH_RETURN_KEY = 'plaid_oauth_return_path';
export const loadPlaidScript = () => {
  if (typeof window === 'undefined' || window.Plaid) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-cau-plaid-link]');
    if (existing) {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', reject);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';
    script.async = true;
    script.dataset.cauPlaidLink = '1';
    script.onload = () => resolve();
    script.onerror = reject;
    document.head.appendChild(script);
  });
};
export const markPlaidOAuthReturn = () => {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.setItem(CAU_PLAID_OAUTH_RETURN_KEY, CAU_PLAID_OAUTH_RETURN_PATH);
};
export const fetchCauPlaidLinkToken = async ({
  axios,
  baseUrl,
  token,
  oauthURI
}) => {
  if (token) {
    const {
      data
    } = await axios.request({
      method: 'POST',
      url: `${baseUrl}/users/me/plaid/link-token`,
      headers: {
        authorization: `Bearer CAU:${token}`
      },
      data: {
        context: 'cau_web'
      }
    });
    return data.link_token;
  }
  const {
    link_token
  } = await axios.$post('/api/members/plaid/link-token', {
    previous: !!oauthURI
  });
  return link_token;
};
export const submitCauPlaidLink = async ({
  axios,
  baseUrl,
  token,
  publicToken,
  accountId
}) => {
  const payload = {
    public_token: publicToken,
    account_id: accountId,
    context: 'cau_web'
  };
  if (token) {
    const {
      data
    } = await axios.request({
      method: 'POST',
      url: `${baseUrl}/users/me/plaid`,
      headers: {
        authorization: `Bearer CAU:${token}`
      },
      data: payload
    });
    return data;
  }
  return axios.$post('/api/members/cau/plaid', payload);
};
export const openCauPlaidLink = async ({
  axios,
  baseUrl,
  token,
  oauthURI,
  onSuccess,
  onExit
}) => {
  await loadPlaidScript();
  if (!window.Plaid) {
    throw new Error('plaid script unavailable');
  }
  markPlaidOAuthReturn();
  const linkToken = await fetchCauPlaidLinkToken({
    axios,
    baseUrl,
    token,
    oauthURI
  });
  const plaidLink = window.Plaid.create({
    token: linkToken,
    ...(oauthURI && {
      receivedRedirectUri: oauthURI
    }),
    onSuccess: onSuccess,
    onExit: onExit
  });
  plaidLink.open();
  return plaidLink;
};